$(() => {
  $('details[data-persist-open]').each((_, el) => {
    const $el = $(el);
    const id = 'details-open-' + $el.data('persist-open');

    let persistedState = localStorage.getItem(id);
    if (persistedState) {
      $el.prop('open', persistedState === 'true');
    }

    $el.on('toggle', () => {
      localStorage.setItem(id, ($el.prop('open')));
    })

    setTimeout(() => $el.attr('data-persist-open', null));
  });
});
